// @Vendors
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// @Components
import StaticImg from '../StaticImg';

class TopNavBar extends Component {

	static propTypes = {
		name: PropTypes.string.isRequired,
		onLogout: PropTypes.func.isRequired,
		pic: PropTypes.string.isRequired,
		rol: PropTypes.string.isRequired,
		surname: PropTypes.string.isRequired,
  };

	render() {
		const { name, onLogout, pic, rol, surname } = this.props;
		return (
			<div id='top_bar'>
				<div className='box'>
					<div id='pic_backuser'>
						<StaticImg src={pic} />
					</div>
					<div className='info'>
						<div className='name'>
							{name}<br />
							{surname}
						</div>
						{/*<div className='rol'>{rol}</div>*/}
					</div>
					<button id='btn_mobile'>
						<i></i>
						<i></i>
						<i></i>
					</button>
					<button onClick={onLogout} id='btn_logout'>
						<StaticImg src='icon/icon_logout.svg' />
					</button>
				</div>
			</div>
		);
	}
}

export default TopNavBar;



// WEBPACK FOOTER //
// ./src/components/nav/TopNavBar.js